import LocalTextInput from 'components/FilterPanel/LocalTextInput';
import React from 'react';
import Points from 'components/Points';
import './PointsRangeControl.css';

interface PointsRangeControlProps {
  min: string;
  max: string;
  onChange: (patch: { pointsMin?: string; pointsMax?: string }) => void;
}

const digitsOnly = (value: string) => value.replace(/\D/g, '');

/**
 * Point-value range filter.
 *
 * Values are points, never dollars, so the control matches what the rest of the
 * app shows on a card. The current bounds echo through the branded Points
 * component rather than as plain numbers.
 */
export const PointsRangeControl: React.FC<PointsRangeControlProps> = ({ min, max, onChange }) => {
  const minValue = min !== '' ? Number(min) : null;
  const maxValue = max !== '' ? Number(max) : null;

  return (
    <div className="points-range-control">
      <div className="points-range-inputs">
        <LocalTextInput
          type="text"
          inputMode="numeric"
          className="points-range-input"
          placeholder="Min"
          aria-label="Minimum points"
          value={min}
          sanitize={digitsOnly}
          onValueChange={(v) => onChange({ pointsMin: v })}
        />
        <span className="points-range-separator">to</span>
        <LocalTextInput
          type="text"
          inputMode="numeric"
          className="points-range-input"
          placeholder="Max"
          aria-label="Maximum points"
          value={max}
          sanitize={digitsOnly}
          onValueChange={(v) => onChange({ pointsMax: v })}
        />
      </div>

      {(minValue !== null || maxValue !== null) && (
        <div className="points-range-echo">
          {minValue !== null && <Points points={minValue} type="small" />}
          {minValue !== null && maxValue !== null && <span className="points-range-dash">-</span>}
          {maxValue !== null && <Points points={maxValue} type="small" />}
        </div>
      )}
    </div>
  );
};

export default PointsRangeControl;
